var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('router-view'),(_vm.isUserLoggedIn)?_c('Footer',{staticClass:"footer mx-2"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }